import { ProcessCreate } from './ProcessCreate'
import { ProcessEdit } from './ProcessEdit'
import { ProcessList } from './ProcessList'
import { ProcessShow } from './ProcessShow'

export { ProcessCreate, ProcessEdit, ProcessList, ProcessShow }
